module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAABZklEQVQokaWSPS9EURCGnzmOa0k2vlaQSCQUgkYjothEq5KoSERINMIPIFGqdBq9TqH1CzQ+ChIKChFBlmAXQdbau6O41/1gFeIk58yZzDtz3nfOSKanbsxV+vnfOrdFZfgDJsuGFZAy96ivILBjfn1DPayqYuobUfkWl7AegAmcINFLVhQxQmpphfr5ha/Al0E1XtcExcWzIiBOFU5nF7a1jcTgECZZS3J0gsRA2sP5G0Jry8kXa2le26B4e01+dxv3MUvt1BziONwtzvJ+uB9I8nvkMSJCVRVKb6/kVpcxiRoKJ0cUM1cUTo/JTI+QP9jzsBp/3EbphXfhZWsTp7eP5PgMxYsznK5ebFML7s11vOf+z/34NfXPyvYOqgfSvB/skl1dpvT8hPuUwycTUwAgl91164XoHEXFByihoiGFm72PdVPEgxjYsRDXGjoS01zKPSDyfZhCadYIeaO8/ED8YYnw9gnZpIn0BzQdhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk.png
// module id = +7W0
// module chunks = 1